import {Route, Routes} from 'react-router-dom'

import {SetscoAuthLayout} from './SetscoAuthLayout'


import {SetscoLogin} from './components/SetscoLogin'
import {SetscoLoginOTP} from './components/SetscoLoginOTP'

import {SetscoForgotPassword} from './components/SetscoForgotPassword'
import {SetscoForgotPasswordOTP} from './components/SetscoForgotPasswordOTP'

const SetscoAuthPage = () => (
    <Routes>
        <Route element={<SetscoAuthLayout />}>
            <Route path='login' element={<SetscoLogin />} />
            <Route path='otp' element={<SetscoLoginOTP />} />
            <Route path='forgot-password' element={<SetscoForgotPassword />} />
            <Route path='forgot-password-otp' element={<SetscoForgotPasswordOTP />} />
            <Route index element={<SetscoLogin />} />
        </Route>
    </Routes>
)

export {SetscoAuthPage}
